package com.evoapps.evoshift.ui.user

import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.ui.adaptive.ScrollingRow
import com.evoapps.evoshift.ui.theme.animateItemIfMotion
import com.evoapps.evoshift.widgets.rememberStableText
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.widgets.EvoConfirmDialog
import evoshift.composeapp.generated.resources.template_new
import com.evoapps.evoshift.ui.adaptive.ListMaxWidth
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.AdaptiveCardGrid
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.TwoPane
import com.evoapps.evoshift.ui.adaptive.WideContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.adaptive.hoverLift
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.items
import com.evoapps.evoshift.ui.util.asString
import evoshift.composeapp.generated.resources.availability_available
import evoshift.composeapp.generated.resources.availability_unavailable
import evoshift.composeapp.generated.resources.template_edit
import evoshift.composeapp.generated.resources.templates_define_days
import evoshift.composeapp.generated.resources.templates_no_slots
import evoshift.composeapp.generated.resources.templates_title
import evoshift.composeapp.generated.resources.delete
import evoshift.composeapp.generated.resources.template_delete
import evoshift.composeapp.generated.resources.template_delete_confirm
import evoshift.composeapp.generated.resources.template_name
import evoshift.composeapp.generated.resources.template_name_hint
import evoshift.composeapp.generated.resources.templates_empty
import evoshift.composeapp.generated.resources.templates_preferred_shifts
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Save
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.evoapps.evoshift.domain.model.AvailabilitySlot
import com.evoapps.evoshift.domain.model.AvailabilityStatus
import com.evoapps.evoshift.domain.model.DayPreference
import com.evoapps.evoshift.domain.model.WeeklyAvailabilityTemplate
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.CardSurface
import com.evoapps.evoshift.ui.CardHairline
import com.evoapps.evoshift.widgets.SurfaceCard
import com.evoapps.evoshift.viewmodels.WeeklyTemplatesEvent
import com.evoapps.evoshift.viewmodels.WeeklyTemplatesViewModel
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.cancel
import evoshift.composeapp.generated.resources.day_friday
import evoshift.composeapp.generated.resources.day_monday
import evoshift.composeapp.generated.resources.day_saturday
import evoshift.composeapp.generated.resources.day_sunday
import evoshift.composeapp.generated.resources.day_thursday
import evoshift.composeapp.generated.resources.day_tuesday
import evoshift.composeapp.generated.resources.day_wednesday
import evoshift.composeapp.generated.resources.save
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun WeeklyTemplatesScreen(
    viewModel: WeeklyTemplatesViewModel,
    onNavigateBack: () -> Unit
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }

    var showDeleteConfirm by remember { mutableStateOf<String?>(null) }

    val errorText = state.error?.asString()

    LaunchedEffect(errorText) {
        errorText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(WeeklyTemplatesEvent.ClearMessage)
        }
    }

    LaunchedEffect(state.success) {
        if (state.success) {
            viewModel.onEvent(WeeklyTemplatesEvent.ClearMessage)
        }
    }

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        containerColor = Color.White,
        topBar = {
            EvoTopBar(
                title = when {
                    state.editingTemplate == null -> stringResource(Res.string.templates_title)
                    state.editingTemplate!!.id.isBlank() -> stringResource(Res.string.template_new)
                    else -> stringResource(Res.string.template_edit)
                },
                onBack = {
                    if (state.editingTemplate != null) viewModel.onEvent(WeeklyTemplatesEvent.SetEditingTemplate(null))
                    else onNavigateBack()
                },
                actions = buildList {
                    add(helpAction(HelpPage.AVAILABILITY_WEEK_TEMPLATES))
                    if (state.editingTemplate == null) {
                        add(
                            TopBarAction(stringResource(Res.string.template_new), Icons.Default.Add, {
                                val defaultDays = (1..7).associate { i ->
                                    i to DayPreference(AvailabilityStatus.AVAILABLE, null, null)
                                }
                                viewModel.onEvent(
                                    WeeklyTemplatesEvent.SetEditingTemplate(
                                        WeeklyAvailabilityTemplate(
                                            id = "",
                                            name = "",
                                            userId = state.userId,
                                            workplaceId = state.workplaceId,
                                            days = defaultDays
                                        )
                                    )
                                )
                            }, collapsible = false)
                        )
                    }
                }
            )
        }
    ) { padding ->
        if (state.isLoading && state.templates.isEmpty() && state.editingTemplate == null) {
            Box(Modifier.fillMaxSize().padding(padding), contentAlignment = Alignment.Center) {
                CircularProgressIndicator(color = DarkGold)
            }
        } else {
            if (state.editingTemplate != null) {
                TemplateEditor(
                    template = state.editingTemplate!!,
                    availableSlots = state.availableSlots,
                    firstDayOfWeek = state.firstDayOfWeek,
                    modifier = Modifier.padding(padding),
                    onSave = { name, days ->
                        viewModel.onEvent(
                            WeeklyTemplatesEvent.SaveTemplate(
                                state.editingTemplate!!.id,
                                name,
                                days
                            )
                        )
                    },
                    onCancel = { viewModel.onEvent(WeeklyTemplatesEvent.SetEditingTemplate(null)) }
                )
            } else {
                // One column on phones; side by side on tablets and desktops.
                AdaptiveCardGrid(
                    modifier = Modifier.fillMaxSize().padding(padding),
                    maxWidth = WideContentMaxWidth
                ) {
                    if (state.templates.isEmpty()) {
                        item(span = { GridItemSpan(maxLineSpan) }) {
                            Box(
                                Modifier.fillMaxWidth().padding(32.dp),
                                contentAlignment = Alignment.Center
                            ) {
                                Text(stringResource(Res.string.templates_empty), color = Color.Gray)
                            }
                        }
                    } else {
                        items(state.templates, key = { it.id }) { template ->
                            Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) {
                                TemplateItem(
                                    template = template,
                                    firstDayOfWeek = state.firstDayOfWeek,
                                    onClick = {
                                        viewModel.onEvent(
                                            WeeklyTemplatesEvent.SetEditingTemplate(
                                                template
                                            )
                                        )
                                    },
                                    onDelete = { showDeleteConfirm = template.id }
                                )
                            }
                        }
                    }
                }
            }
        }
    }

    showDeleteConfirm?.let { templateId ->
        EvoConfirmDialog(
            title = stringResource(Res.string.template_delete),
            text = stringResource(Res.string.template_delete_confirm),
            confirmLabel = stringResource(Res.string.delete),
            onConfirm = {
                viewModel.onEvent(WeeklyTemplatesEvent.DeleteTemplate(templateId))
                showDeleteConfirm = null
            },
            onDismiss = { showDeleteConfirm = null },
            destructive = true,
            icon = Icons.Default.Delete
        )
    }
}

@Composable
fun TemplateItem(
    template: WeeklyAvailabilityTemplate,
    firstDayOfWeek: Int,
    onClick: () -> Unit,
    onDelete: () -> Unit
) {
    Card(
        onClick = onClick,
        modifier = Modifier.fillMaxWidth().hoverLift(),
        // SH-230: the light cards' white surface and hairline edge (was a cream fill).
        colors = CardDefaults.cardColors(containerColor = CardSurface, contentColor = DeepNavy),
        border = BorderStroke(1.dp, CardHairline),
        elevation = CardDefaults.cardElevation(defaultElevation = 1.dp)
    ) {
        Row(
            modifier = Modifier.padding(16.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(modifier = Modifier.weight(1f)) {
                Text(
                    template.name,
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy
                )
                Spacer(Modifier.height(8.dp))

                // Summary line of days reordered by firstDayOfWeek
                Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                    val baseLabels = listOf("M", "T", "W", "T", "F", "S", "S")
                    val dayOrder = (0..6).map { (it + firstDayOfWeek - 1) % 7 + 1 }

                    for (i in dayOrder) {
                        val pref = template.days[i]
                        val statusColor = when (pref?.status) {
                            AvailabilityStatus.AVAILABLE -> Color(0xFF2E7D32)
                            AvailabilityStatus.UNAVAILABLE -> Color(0xFFD32F2F)
                            else -> Color.Gray.copy(alpha = 0.3f)
                        }

                        Box(
                            modifier = Modifier
                                .size(24.dp)
                                .clip(CircleShape)
                                .background(statusColor),
                            contentAlignment = Alignment.Center
                        ) {
                            Text(
                                text = baseLabels[i - 1],
                                fontSize = 10.sp,
                                color = if (pref != null) Color.White else DeepNavy.copy(alpha = 0.75f),
                                fontWeight = FontWeight.Bold
                            )
                        }
                    }
                }
            }
            IconButton(onClick = onDelete) {
                Icon(Icons.Default.Delete, null, tint = Color.Red.copy(alpha = 0.6f))
            }
        }
    }
}

@Composable
fun TemplateEditor(
    template: WeeklyAvailabilityTemplate,
    availableSlots: List<AvailabilitySlot>,
    firstDayOfWeek: Int,
    modifier: Modifier = Modifier,
    onSave: (String, Map<Int, DayPreference>) -> Unit,
    onCancel: () -> Unit
) {
    // Ensure state is fresh for the given template
    var name by remember(template.id) { mutableStateOf(template.name) }
    var days by remember(template.id) { mutableStateOf(template.days) }
    var selectedDayOfWeek by remember { mutableStateOf(firstDayOfWeek) } // Start with first day

    val isExpanded = LocalWindowWidthClass.current.isExpanded
    // Wide windows: name and week on the left, the chosen day and the actions on the right.
    // Each pane keeps the 16dp rhythm, so the stacked phone layout is unchanged.
    TwoPane(
        // SH-130: the scroll fills the screen; the editor is a centred column inside it.
        modifier = modifier.fillMaxSize().verticalScroll(rememberScrollState()).contentWidth(ListMaxWidth).padding(16.dp),
        spacing = if (isExpanded) 32.dp else 16.dp,
        first = {
            Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                rememberStableText(name, { name = it }).let { stable ->
                    OutlinedTextField(
                        value = stable.value,
                        onValueChange = stable.onValueChange,
                        label = { Text(stringResource(Res.string.template_name)) },
                        placeholder = { Text(stringResource(Res.string.template_name_hint)) },
                        modifier = Modifier.fillMaxWidth(),
                        colors = OutlinedTextFieldDefaults.colors(
                            focusedBorderColor = DeepNavy,
                            unfocusedBorderColor = Color.Gray
                        )
                    )
                }

                Text(
                    stringResource(Res.string.templates_define_days),
                    style = MaterialTheme.typography.titleSmall,
                    fontWeight = FontWeight.Bold
                )

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    val baseLabels = listOf(
                        Res.string.day_monday,
                        Res.string.day_tuesday,
                        Res.string.day_wednesday,
                        Res.string.day_thursday,
                        Res.string.day_friday,
                        Res.string.day_saturday,
                        Res.string.day_sunday
                    )

                    val dayOrder = (0..6).map { (it + firstDayOfWeek - 1) % 7 + 1 }

                    dayOrder.forEach { dayNum ->
                        val label = stringResource(baseLabels[dayNum - 1]).take(1)
                        val isSelected = selectedDayOfWeek == dayNum
                        val hasData = days.containsKey(dayNum)

                        Box(
                            modifier = Modifier
                                .size(40.dp)
                                .clip(CircleShape)
                                .background(
                                    if (isSelected) DeepNavy else if (hasData) {
                                        if (days[dayNum]?.status == AvailabilityStatus.AVAILABLE) Color(
                                            0xFF4CAF50
                                        ).copy(alpha = 0.2f)
                                        else Color(0xFFD32F2F).copy(alpha = 0.2f)
                                    } else Color.Transparent
                                )
                                .border(
                                    1.dp,
                                    if (isSelected) DeepNavy else Color.Gray.copy(alpha = 0.3f),
                                    CircleShape
                                )
                                .handCursor()
                                .clickable { selectedDayOfWeek = dayNum },
                            contentAlignment = Alignment.Center
                        ) {
                            Text(
                                text = label,
                                color = if (isSelected) Color.White else DeepNavy,
                                fontWeight = FontWeight.Bold
                            )
                        }
                    }
                }
            }
        },
        second = {
            Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                val currentDayPref =
                    days[selectedDayOfWeek] ?: DayPreference(AvailabilityStatus.AVAILABLE, null, null)

                SurfaceCard(modifier = Modifier.fillMaxWidth()) {
                    Column(
                        modifier = Modifier.padding(16.dp),
                        verticalArrangement = Arrangement.spacedBy(12.dp)
                    ) {
                        val dayFullName = stringResource(getDayNameRes(selectedDayOfWeek))

                        Text(dayFullName, fontWeight = FontWeight.Bold, color = DeepNavy)

                        // Status Toggle
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(40.dp)
                                .clip(RoundedCornerShape(8.dp))
                                .border(1.dp, DeepNavy.copy(alpha = 0.1f), RoundedCornerShape(8.dp))
                        ) {
                            Box(
                                modifier = Modifier
                                    .weight(1f)
                                    .fillMaxHeight()
                                    .background(
                                        if (currentDayPref.status == AvailabilityStatus.UNAVAILABLE) Color(
                                            0xFFD32F2F
                                        ) else Color.Transparent
                                    )
                                    .handCursor()
                                    .clickable {
                                        days = days.toMutableMap().apply {
                                            put(
                                                selectedDayOfWeek,
                                                currentDayPref.copy(status = AvailabilityStatus.UNAVAILABLE)
                                            )
                                        }
                                    },
                                contentAlignment = Alignment.Center
                            ) {
                                Text(
                                    stringResource(Res.string.availability_unavailable),
                                    color = if (currentDayPref.status == AvailabilityStatus.UNAVAILABLE) Color.White else Color.Red,
                                    fontSize = 12.sp
                                )
                            }
                            Box(
                                modifier = Modifier
                                    .weight(1f)
                                    .fillMaxHeight()
                                    .background(
                                        if (currentDayPref.status == AvailabilityStatus.AVAILABLE) Color(
                                            0xFF4CAF50
                                        ) else Color.Transparent
                                    )
                                    .handCursor()
                                    .clickable {
                                        days = days.toMutableMap().apply {
                                            put(
                                                selectedDayOfWeek,
                                                currentDayPref.copy(status = AvailabilityStatus.AVAILABLE)
                                            )
                                        }
                                    },
                                contentAlignment = Alignment.Center
                            ) {
                                Text(
                                    stringResource(Res.string.availability_available),
                                    color = if (currentDayPref.status == AvailabilityStatus.AVAILABLE) Color.White else Color(
                                        0xFF4CAF50
                                    ),
                                    fontSize = 12.sp
                                )
                            }
                        }

                        if (currentDayPref.status == AvailabilityStatus.AVAILABLE) {
                            Text(stringResource(Res.string.templates_preferred_shifts), style = MaterialTheme.typography.labelSmall)

                            if (availableSlots.isEmpty()) {
                                Text(
                                    stringResource(Res.string.templates_no_slots),
                                    color = Color.Gray,
                                    fontSize = 12.sp
                                )
                            } else {
                                ScrollingRow(
                                    modifier = Modifier.fillMaxWidth(),
                                    horizontalArrangement = Arrangement.spacedBy(8.dp)
                                ) {
                                    availableSlots.forEach { slot ->
                                        val isSelected = currentDayPref.preferredSlotId == slot.id
                                        Box(
                                            modifier = Modifier
                                                .border(
                                                    0.5.dp,
                                                    if (isSelected) DeepNavy else Color.Gray.copy(alpha = 0.3f),
                                                    RoundedCornerShape(12.dp)
                                                )
                                                .clip(RoundedCornerShape(12.dp))
                                                .background(if (isSelected) DeepNavy.copy(alpha = 0.1f) else Color.Transparent)
                                                .handCursor()
                                                .clickable {
                                                    days = days.toMutableMap().apply {
                                                        put(
                                                            selectedDayOfWeek,
                                                            currentDayPref.copy(preferredSlotId = if (isSelected) null else slot.id)
                                                        )
                                                    }
                                                }
                                                .padding(horizontal = 12.dp, vertical = 8.dp)
                                        ) {
                                            Text(slot.label, fontSize = 11.sp, color = DeepNavy)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                Spacer(Modifier.height(16.dp))

                Button(
                    onClick = { onSave(name, days) },
                    modifier = Modifier.fillMaxWidth().height(48.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = DarkGold),
                    enabled = name.isNotBlank() && days.isNotEmpty()
                ) {
                    Icon(Icons.Default.Save, null)
                    Spacer(Modifier.width(8.dp))
                    Text(stringResource(Res.string.save), fontWeight = FontWeight.Bold)
                }

                TextButton(
                    onClick = onCancel,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Text(stringResource(Res.string.cancel), color = DeepNavy)
                }
            }
        }
    )
}

fun getDayNameRes(isoDay: Int): StringResource {
    return when (isoDay) {
        1 -> Res.string.day_monday
        2 -> Res.string.day_tuesday
        3 -> Res.string.day_wednesday
        4 -> Res.string.day_thursday
        5 -> Res.string.day_friday
        6 -> Res.string.day_saturday
        else -> Res.string.day_sunday
    }
}
